import React from 'react'
import MobileDrawer from '../MobileComponents/MobileDrawer';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CreateIcon from "@mui/icons-material/Create";
import { useNavigate } from 'react-router-dom';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { blue, red } from '@mui/material/colors';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
// import AttachmentIcon from '@mui/icons-material/Attachment';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 10,
  p: 3,
};
function CustomTabPanel(props) {

  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function MobileGroup() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [groupDetailsModal, setGroupDetailsModal] = React.useState(false);
  const handleOpenGrpDetailsModal = () => setGroupDetailsModal(true);
  const handleCloseGrpDetailsModal = () => setGroupDetailsModal(false);
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openSort = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseSort = () => {
    setAnchorEl(null);
  };

  const initialValues = {
    group_name: "",
    description: "",
  };

  const validationSchema = Yup.object({
    group_name: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
  });

  const onSubmit = (values) => console.log("Form Data", values);
  return (
    <div>
        <div>
        <div className="drawerFixedPatch"></div>
        <div className="drawerWithTop">
          <MobileDrawer />
          <h1>All Groups</h1>
        </div>
        </div>
    <div className='topSpace'></div>
    <div className='tabView'>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="My Groups" {...a11yProps(0)} style={{width:'50%'}}/>
          <Tab label="All Groups" {...a11yProps(1)} style={{width:'50%'}}/>
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={openSort}
          onClose={handleCloseSort}
          onClick={handleCloseSort}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleCloseSort}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleCloseSort}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
        <div className="detailsDiMob" onClick={handleOpenGrpDetailsModal}>
          <h1>Group Name</h1>
          <div className="mobWithIco">
            <p>Created on: 12/10/2024</p>
          </div>
          <div className="mobWithIco">
            <p>Total members: 4</p>
          </div>
        </div>
        <div className="listDeleEdiMob">
          <CreateIcon style={{ color: "#21bd21" }} />
          <DeleteOutlineIcon style={{ color: "#ff5252" }} />
        </div>
        </div>
        <div >
            <button className='AddNewMemberBtnView' type='submit' onClick={()=>navigate('/MobileAddMember')}>Add New Members</button>
        </div>
        </div>
        <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
        <div className="detailsDiMob" onClick={handleOpenGrpDetailsModal}>
          <h1>Group Name</h1>
          <div className="mobWithIco">
            <p>Created on: 12/10/2024</p>
          </div>
          <div className="mobWithIco">
            <p>Total members: 4</p>
          </div>
        </div>
        <div className="listDeleEdiMob">
          <CreateIcon style={{ color: "#21bd21" }} />
          <DeleteOutlineIcon style={{ color: "#ff5252" }} />
        </div>
        </div>
        <div>
          <button className='AddNewMemberBtnView' type='submit' onClick={()=>navigate('/MobileAddMember')}>Add New Members</button>
        </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={openSort}
          onClose={handleCloseSort}
          onClick={handleCloseSort}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleCloseSort}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleCloseSort}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
        <div className="detailsDiMob" onClick={handleOpenGrpDetailsModal}>
          <h1>Group Name</h1>
          <div className="mobWithIco">
            <p>Created on: 12/10/2024</p>
          </div>
          <div className="mobWithIco">
            <p>Created by: Fname Lname</p>
          </div>
          <div className="mobWithIco">
            <p>Total members: 4</p>
          </div>
        </div>
        <div className="GroupExitBtnView">
          <LogoutRoundedIcon style={{ color: "#ff5252" }} />
          <p className='ExitGrpNameTxt'>Exit Group</p>
        </div>
        </div>
        </div>
      </CustomTabPanel>
      </Box>
    </div>
    <div className='flaotBtnAdd'>
      <Fab size="medium" sx={{backgroundColor: '#3853ec'}} aria-label="add" onClick={handleOpen}>
        <AddIcon sx={{fontSize: 32, color:'white'}}/>
      </Fab>
    </div>
    {/*  Add Group Modal */}
    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Add Group</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleClose} />
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => (
              <Form>
          <div className='FormView'>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Group Name"
              placeholder="Enter Group Name"
              labelclassName="inputLebal"
              name="group_name"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="textarea"
              type="text"
              label="Group Description"
              placeholder="Enter Group Description"
              labelclassName="inputLebal"
              name="description"
              className="textAreaInput"
            />
            </div>
            <button className='submitButton' type='submit'>Submit</button>
          </div>
          </Form>
            )}
          </Formik>
        </Box>
    </Modal>
    {/* Group Details Modal */}
    <Modal
        open={groupDetailsModal}
        onClose={handleCloseGrpDetailsModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Group Name Group Members </p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleCloseGrpDetailsModal} />
          </div>
          <div className='FormView'>
            <div className='margineTop10'>
            <div className='GroupMemberList margineTop10'>
                <p className=''>Member Name</p>
                <DeleteOutlineIcon style={{ color: "#ff5252" }} />
            </div>
            <div className='dividerCommon' />
            <div className='GroupMemberList margineTop10'>
                <p>Member Name</p>
                <DeleteOutlineIcon style={{ color: "#ff5252" }} />
            </div>
            <div className='dividerCommon' />
            <div className='GroupMemberList margineTop10'>
                <p>Member Name</p>
                <DeleteOutlineIcon style={{ color: "#ff5252" }} />
            </div>
            <div className='dividerCommon' />
            </div>
          </div>
        </Box>
    </Modal>
    </div>
  )
}

export default MobileGroup;